import React from 'react'
import { Dropdown, Form } from 'semantic-ui-react'

export default function Select(props) {
  const style = {}
  if (props.warning && !props.error) style.background = '#fffaf3'
  if (props.transparent) {
    style.background = 'rgb(255, 250, 243)'
    style.border = '0px'
  }

  return (
    <Form.Field error={props.error} required={props.required}>
      {props.label ? <label>{props.label}</label> : null}

      <Dropdown
        multiple={props.multiple}
        clearable={props.clearable}
        disabled={props.disabled}
        loading={props.loading}
        style={style}
        fluid={props.fluid}
        search={props.search}
        selection={props.selection}
        selectOnBlur={props.selectOnBlur}
        selectOnNavigation={props.selectOnNavigation}
        noResultsMessage={props.noResultsMessage}
        placeholder={props.placeholder || props.label}
        options={props.options}
        value={props.multiple ? (props.value || []) : props.value}
        disabled={props.disabled}
        onChange={(_, { value }) =>
          props.onChange(props.multiple ? (value || []) : value)
        }
      />
    </Form.Field>
  )
}

Select.defaultProps = {
  clearable: false,
  label: null,
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  warning: false,
  options: [],
  value: null,
  onChange: () => { },
  fluid: true,
  search: true,
  selection: true,
  selectOnBlur: false,
  selectOnNavigation: false,
  noResultsMessage: null,
  multiple: false
}
